import './playersearchresults.css';
import { Link } from 'react-router-dom';

const DEFAULT_PROFILE_PHOTO =
  'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png';

export default function PlayerSearchResults({
  searchedPlayers = [],
  onPlayerClick,
  selectable = false,
  onPlayerSelect,
  showDisplayName = false,
}) {
  return (
    <>
      <div>
        <ul className="ulollist">
          {searchedPlayers.map((player) => {
            const profilePhoto = player.profilePhoto || DEFAULT_PROFILE_PHOTO;
            const displayName =
              showDisplayName &&
              (player.displayName || player.name || player.fullName || '');
            const content = (
              <div className="playerSearchResult">
                <img
                  src={profilePhoto}
                  alt=""
                  className="topbarImg"
                />
                <span className="searchedPlayersPlayerId">
                  {player.playerId}
                  {displayName ? <small>{displayName}</small> : null}
                </span>
              </div>
            );

            if (selectable) {
              return (
                <li key={player._id || player.playerId}>
                  <button
                    type="button"
                    className="playerSearchResultButton"
                    onClick={() => {
                      if (onPlayerSelect) onPlayerSelect(player);
                      if (onPlayerClick) onPlayerClick(player);
                    }}
                  >
                    {content}
                  </button>
                </li>
              );
            }

            return (
              <li key={player._id || player.playerId}>
                <Link
                  to={'/profile/' + player.playerId}
                  style={{ textDecoration: 'none' }}
                  onClick={() => {
                    if (onPlayerClick) onPlayerClick(player);
                  }}
                >
                  {content}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}
